/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { attributes, className } = props;
	const { stretchContainer, fullWidthStretchContainer } = attributes;

	const wrapperClasses = classnames(
		className,
		stretchContainer ? 'gutenify-container-stretch' : '',
		stretchContainer ? 'gutenify-container-stretch' : '',
		stretchContainer && fullWidthStretchContainer ? 'gutenify-container-full-width-stretch' : '',
		'gutenify-block-container-wrapper'
	);

	return (
		<div className={ wrapperClasses }>
			<div className="gutenify-container">
				<InnerBlocks.Content />
			</div>
		</div>

	);
}

